<template>
  <div class="bm-wrap">
    <modal
      name="bannerModal"
      @before-close="onClose"
      class="bm-modal"
      :adaptive="true"
      :scrollable="true"
      height="auto"
      width="90%"
      :maxWidth="620"
    >
      <div class="bm-dialog">

        <!-- Header -->
        <div class="bm-dialog-header">
          <div class="bm-dialog-header-left">
            <span class="bm-dialog-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>
              </svg>
            </span>
            <div>
              <h2 class="bm-dialog-title">{{ type }} Banner</h2>
              <p class="bm-dialog-sub">Upload an image and set a link for the in-app banner</p>
            </div>
          </div>
          <button class="bm-close-btn" @click="$modal.hide('bannerModal')" title="Close">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <!-- Body -->
        <div class="bm-dialog-body">

          <!-- Upload section -->
          <div class="bm-field">
            <label class="bm-label">Banner Image</label>
            <div class="bm-upload-row">
              <label class="bm-file-zone" :class="{ 'bm-file-zone--error': hasError }">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/>
                </svg>
                <span>{{ file && file.name ? file.name : 'Choose image (3:1 ratio, max 1 MB)' }}</span>
                <input
                  type="file"
                  id="uploadInputFile"
                  name="photo"
                  accept="image/*"
                  @change="changeFileHandle"
                  class="bm-file-hidden"
                />
              </label>
              <button class="bm-upload-btn" :disabled="choosed" @click="onupload()">
                <svg v-if="!uploadingBar" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                <span>{{ uploadingBar ? uploadPercentage + '%' : 'Upload' }}</span>
              </button>
            </div>

            <!-- Errors -->
            <p v-if="hasError" class="bm-error">{{ errorMessage }}</p>
            <p v-if="aspectRatioError" class="bm-error">{{ aspectRatioError }}</p>

            <!-- Progress -->
            <div v-if="uploadingBar" class="bm-progress">
              <div class="bm-progress-bar" :style="{ width: uploadPercentage + '%' }"></div>
            </div>
          </div>

          <!-- Previews -->
          <div v-if="url || bannerDetail.ImageUrl" class="bm-previews">
            <div v-if="url" class="bm-preview-item">
              <span class="bm-preview-badge bm-preview-badge--new">Preview</span>
              <img :src="url" id="image" alt="Preview" class="bm-preview-img" />
            </div>
            <div v-if="bannerDetail.ImageUrl" class="bm-preview-item">
              <div class="bm-preview-actions">
                <span class="bm-preview-badge bm-preview-badge--saved">Saved</span>
                <button class="bm-remove-btn" @click="confirmRemoveBanner" title="Remove">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg>
                  Remove
                </button>
              </div>
              <img :src="bannerDetail.ImageUrl" alt="Banner" class="bm-preview-img" />
            </div>
          </div>

          <!-- Saved link display -->
          <div v-if="bannerLink" class="bm-saved-link">
            <span class="bm-preview-badge bm-preview-badge--saved">Current Link</span>
            <a :href="bannerLink" target="blank" class="bm-link">{{ bannerLink }}</a>
          </div>

          <!-- Banner Link -->
          <div class="bm-field">
            <label class="bm-label">Banner Link (URL)</label>
            <input
              type="text"
              v-model="bannerDetail.Link"
              name="Link"
              class="bm-input"
              placeholder="https://example.com"
            />
            <p v-if="linkError" class="bm-error">{{ linkError }}</p>
          </div>

          <!-- Banner Type -->
          <div class="bm-field">
            <label class="bm-label">Banner Type</label>
            <div class="bm-select-wrap">
              <select v-model="bannerDetail.Type" name="type" class="bm-select">
                <option value="REGULAR">Regular</option>
                <option value="US BANNER">US Banner</option>
              </select>
              <svg class="bm-select-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
            </div>
          </div>

        </div>

        <!-- Footer -->
        <div class="bm-dialog-footer">
          <button class="bm-cancel-btn" @click="$modal.hide('bannerModal')">Cancel</button>
          <button class="bm-save-btn" id="save-banner" @click="saveBanner()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg>
            Save Banner
          </button>
        </div>

      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue"
import { mapGetters, mapActions } from 'vuex'
import Selectize from '@/components/Selectize'
import TextField from '@/components/Forms/TextField'
import S3UploadService from "@/services/s3Upload"
import axios from 'axios'
import VuejsDialog from 'vuejs-dialog'

Vue.use(VuejsDialog)

let dialogOptions = {
  html: false, loader: false, reverse: false,
  cancelText: 'No', okText: 'Yes', animation: 'zoom', type: 'basic'
}

export default {
  name: "add-edit-banner",
  data: () => ({
    bannerDetail: { ImageUrl: "", Link: "", Type: "REGULAR", AddedBy: '', LastModBy: '', AddedOn: '', LastModOn: '' },
    bannerLink: '',
    suceessmessage: null,
    errorMessage: "Fill in the photo with size below 1 mb",
    aspectRatioError: null,
    uploadingBar: false,
    msg: 'Are you sure want to remove banner?',
    hasError: false,
    choosed: true,
    file: {},
    url: null,
    uploadPercentage: 0,
    interval: null,
    suceessLinkMessage: false,
    linkError: null,
  }),
  props: { show: false, bannerData: {}, type: '' },
  computed: {
    ...mapGetters({ trainer: 'Trainer/trainer' })
  },
  methods: {
    changeHandle() { this.invalidError = false; this.invalidMsg = "" },
    confirmRemoveBanner() {
      this.$dialog.confirm("Are you sure want to remove banner?", dialogOptions)
        .then(() => { this.selectNoBanner('NORMAL') })
    },
    onClose() { this.reset(); this.$emit("closed", true) },
    openBannerModal() {
      if (this.type == 'Edit') {
        Object.assign(this.bannerDetail, this.bannerData)
        this.bannerLink = this.bannerDetail.Link
      }
      this.$modal.show('bannerModal')
    },
    changeFileHandle(e) {
      this.suceessmessage = null
      const originalFile = e.target.files[0]
      this.url = URL.createObjectURL(originalFile)
      const file = new FormData()
      file.append("file", originalFile)
      const size = originalFile.size / 1024
      if (size > 1024) {
        this.hasError = true; this.aspectRatioError = null; this.choosed = true
      } else {
        this.hasError = false; this.aspectRatioError = null; this.choosed = false
        this.file.name = originalFile.name; this.file.data = originalFile
      }
    },
    uploadImageToS3() {
      return new Promise((resolve, reject) => {
        var that = this
        let aspectRatio = document.getElementById("image").clientWidth / document.getElementById("image").clientHeight
        aspectRatio = Math.round(aspectRatio)
        if (aspectRatio == 3) {
          this.aspectRatioError = null; this.hasError = false; this.uploadingBar = true; this.startBar()
          S3UploadService.uploadAndGetBannerLink(this.file, "NORMAL", (data, err) => {
            that.bannerDetail.ImageUrl = data; that.stopBar(); that.uploadingBar = false
            that.uploadPercentage = 0; that.suceessmessage = true; that.url = null; that.choosed = true
            setTimeout(() => { that.suceessmessage = false }, 2000)
            if (err) reject(err); else resolve(data)
          })
        } else {
          this.aspectRatioError = "Please upload an image with 3:1 aspect ratio"
          this.choosed = true; reject(new Error("Invalid aspect ratio"))
        }
      })
    },
    async onupload() {
      try { await this.uploadImageToS3() } catch (error) { console.error("Upload failed:", error) }
    },
    selectNoBanner() { this.bannerDetail.ImageUrl = '' },
    startBar() { this.interval = setInterval(() => { if (this.uploadPercentage < 95) this.uploadPercentage += 10 }, 200) },
    stopBar() { clearInterval(this.interval); this.uploadPercentage = 100 },
    isUrlValid(userInput) {
      if (userInput == '') return true
      var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
      return res != null
    },
    async saveBanner() {
      var that = this
      const valid = await this.isUrlValid(this.bannerDetail.Link)
      if (valid) { this.linkError = null } else { this.linkError = 'Banner link is not valid'; return }
      if (this.file && this.file.data && !this.bannerDetail.ImageUrl) {
        try { await this.uploadImageToS3() } catch (error) { this.resetSaveButton(); return }
      }
      this.bannerDetail.LastModBy = this.trainer.id
      this.bannerDetail.LastModOn = new Date().toISOString()
      this.saveButton()
      if (this.type == 'Edit') {
        axios.post(this.$expressApi + `editBanner?staging=` + this.$isStage, this.bannerDetail)
          .then(response => { that.resetSaveButton(); that.$emit('saved'); that.$modal.hide('bannerModal') })
          .catch(e => { that.resetSaveButton(); console.log("Error:", e) })
      } else {
        this.bannerDetail.AddedBy = this.trainer.id
        this.bannerDetail.AddedOn = new Date().toISOString()
        axios.post(this.$expressApi + `addBanner?staging=` + this.$isStage, this.bannerDetail)
          .then(response => { that.resetSaveButton(); that.$emit('saved'); that.$modal.hide('bannerModal') })
          .catch(e => { that.resetSaveButton(); console.log("Error:", e) })
      }
    },
    reset() {
      this.bannerDetail = { ImageUrl: "", Link: "", Type: "REGULAR", AddedBy: '', LastModBy: '', AddedOn: '', LastModOn: '' }
      this.bannerLink = ''; this.suceessmessage = null
      this.errorMessage = "Fill in the photo with size below 1 mb"; this.aspectRatioError = null
      this.uploadingBar = false; this.hasError = false; this.choosed = true
      this.file = {}; this.url = null; this.uploadPercentage = 0
      this.interval = null; this.suceessLinkMessage = false; this.linkError = null
      var inp = document.getElementById("uploadInputFile")
      if (inp) inp.value = ""
    },
    saveButton() {
      const btnsave = document.querySelector('#save-banner')
      btnsave.innerHTML = '<span>Saving…</span>'; btnsave.setAttribute('disabled', true)
    },
    resetSaveButton() {
      const btnsave = document.querySelector('#save-banner')
      btnsave.innerHTML = 'Save Banner'; btnsave.removeAttribute('disabled')
    }
  },
  watch: {
    show(oldVal, newVal) { if (this.show) this.openBannerModal() }
  },
  components: { Selectize, TextField }
}
</script>

<style>
/* ── Banner modal overlay ─────────────────────────────────────── */
.bm-modal .v--modal-overlay { background: rgba(10,10,30,0.45) !important; }
.bm-modal .v--modal { border-radius: 16px !important; box-shadow: 0 8px 40px rgba(0,0,0,0.18) !important; overflow: hidden !important; }

/* Purple button hover glow */
.bm-save-btn, .bm-upload-btn {
  transition: background 0.15s, box-shadow 0.15s, transform 0.15s;
}
.bm-save-btn:hover:not(:disabled), .bm-upload-btn:hover:not(:disabled) {
  box-shadow: 0 4px 16px rgba(91, 79, 207, 0.38);
  transform: translateY(-1px);
}
/* Cursor on all interactive zones */
.bm-file-zone, .bm-close-btn, .bm-cancel-btn,
.bm-save-btn, .bm-upload-btn, .bm-remove-btn { cursor: pointer; }

/* Dialog shell */
.bm-dialog { display: flex; flex-direction: column; background: #fff; border-radius: 16px; overflow: hidden; }

/* Header */
.bm-dialog-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  padding: 1.5rem 1.75rem 1.25rem;
  border-bottom: 1px solid #f0f0f5;
  gap: 12px;
}
.bm-dialog-header-left { display: flex; align-items: flex-start; gap: 12px; }
.bm-dialog-icon {
  display: flex; align-items: center; justify-content: center;
  width: 36px; height: 36px; border-radius: 10px;
  background: #f0effe; color: #5b4fcf; flex-shrink: 0;
}
.bm-dialog-title { font-size: 16px; font-weight: 700; color: #1a1a2e; margin: 0 0 3px 0; letter-spacing: -0.01em; }
.bm-dialog-sub   { font-size: 12px; color: #8a8a9a; margin: 0; }
.bm-close-btn {
  display: flex; align-items: center; justify-content: center;
  width: 30px; height: 30px; border-radius: 8px; border: 1px solid #e8e8ed;
  background: #fafafa; color: #8a8a9a; cursor: pointer; flex-shrink: 0;
  transition: border-color 0.15s, color 0.15s;
}
.bm-close-btn:hover { border-color: #c0392b; color: #c0392b; }

/* Body */
.bm-dialog-body { padding: 1.5rem 1.75rem; display: flex; flex-direction: column; gap: 1.1rem; }

/* Field */
.bm-field { display: flex; flex-direction: column; gap: 6px; }
.bm-label { font-size: 12px; font-weight: 600; color: #4a4a6a; letter-spacing: 0.01em; }

/* Upload row */
.bm-upload-row { display: flex; gap: 8px; align-items: stretch; }
.bm-file-zone {
  flex: 1; display: flex; align-items: center; gap: 8px;
  background: #fafafa; border: 1.5px dashed #d0d0e0; border-radius: 9px;
  padding: 9px 14px; font-size: 12.5px; color: #8a8a9a; cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
}
.bm-file-zone:hover { border-color: #5b4fcf; background: #f7f5ff; color: #5b4fcf; }
.bm-file-zone--error { border-color: #e74c3c; background: #fff8f8; }
.bm-file-hidden { display: none; }
.bm-upload-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: auto; padding: 0 16px; border-radius: 9px; border: none;
  background: #5b4fcf; color: #fff; font-size: 13px; font-weight: 600;
  cursor: pointer; transition: background 0.15s; flex-shrink: 0;
}
.bm-upload-btn:hover:not(:disabled) { background: #4338ca; }
.bm-upload-btn:disabled { opacity: 0.45; cursor: not-allowed; }

/* Progress */
.bm-progress { height: 3px; background: #e8e8ed; border-radius: 3px; overflow: hidden; }
.bm-progress-bar { height: 100%; background: linear-gradient(90deg, #5b4fcf, #9c8dff); border-radius: 3px; transition: width 0.2s; }

/* Previews */
.bm-previews { display: flex; gap: 1rem; }
.bm-preview-item { flex: 1; display: flex; flex-direction: column; gap: 6px; }
.bm-preview-actions { display: flex; align-items: center; justify-content: space-between; }
.bm-preview-img { width: 100%; aspect-ratio: 3/1; object-fit: cover; border-radius: 8px; border: 1px solid #eaeaf0; }
.bm-preview-badge {
  font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.06em;
  padding: 2px 8px; border-radius: 20px;
}
.bm-preview-badge--new   { background: #eeeafc; color: #5b4fcf; }
.bm-preview-badge--saved { background: #e8f5e9; color: #2e7d32; }
.bm-remove-btn {
  display: inline-flex; align-items: center; gap: 4px;
  font-size: 11px; font-weight: 600; color: #c0392b;
  background: none; border: none; cursor: pointer; padding: 0;
}
.bm-remove-btn:hover { text-decoration: underline; }

/* Saved link */
.bm-saved-link { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.bm-link { font-size: 12px; color: #4338ca; word-break: break-all; }

/* Input */
.bm-input {
  width: 100%; border: 1.5px solid #e0e0ea; border-radius: 8px;
  padding: 9px 12px; font-size: 13px; color: #1a1a2e;
  background: #fff; box-sizing: border-box; outline: none;
  transition: border-color 0.15s;
}
.bm-input:focus { border-color: #5b4fcf; }

/* Select */
.bm-select-wrap { position: relative; display: inline-flex; align-items: center; }
.bm-select {
  appearance: none; -webkit-appearance: none;
  border: 1.5px solid #e0e0ea; border-radius: 8px;
  padding: 8px 32px 8px 12px; font-size: 13px; color: #1a1a2e;
  background: #fff; cursor: pointer; outline: none;
  transition: border-color 0.15s; min-width: 160px;
}
.bm-select:focus { border-color: #5b4fcf; }
.bm-select-icon { position: absolute; right: 10px; pointer-events: none; color: #8a8a9a; }

/* Error */
.bm-error { font-size: 12px; color: #c0392b; margin: 0; }

/* Footer */
.bm-dialog-footer {
  display: flex; align-items: center; justify-content: flex-end; gap: 10px;
  padding: 1rem 1.75rem 1.5rem;
  border-top: 1px solid #f0f0f5;
}
.bm-cancel-btn {
  height: 36px; padding: 0 16px; border-radius: 8px;
  border: 1.5px solid #e0e0ea; background: #fff; color: #8a8a9a;
  font-size: 13px; font-weight: 600; cursor: pointer;
  transition: border-color 0.15s, color 0.15s;
}
.bm-cancel-btn:hover { border-color: #5b4fcf; color: #5b4fcf; }
.bm-save-btn {
  display: inline-flex; align-items: center; gap: 6px;
  height: 36px; padding: 0 18px; border-radius: 8px;
  border: none; background: #5b4fcf; color: #fff;
  font-size: 13px; font-weight: 600; cursor: pointer;
  transition: background 0.15s;
}
.bm-save-btn:hover:not(:disabled) { background: #4338ca; }
.bm-save-btn:disabled { opacity: 0.45; cursor: not-allowed; }
</style>



// WEBPACK FOOTER //
// AddEditBanner.vue?2a9ab1c5